import { SVGProps } from 'react';

export const IconCopy = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' fill='none' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.8 5.6H18.4V15.2H8.8V5.6ZM7.2 5.6C7.2 4.71634 7.91634 4 8.8 4H18.4C19.2837 4 20 4.71634 20 5.6V15.2C20 16.0837 19.2837 16.8 18.4 16.8H16.8V18.4C16.8 19.2837 16.0837 20 15.2 20H10.4H5.6C4.71634 20 4 19.2837 4 18.4V8.8C4 7.91634 4.71634 7.2 5.6 7.2H7.2V5.6ZM7.2 8.8H5.6V18.4H15.2V16.8H8.8C7.91634 16.8 7.2 16.0837 7.2 15.2V8.8Z'
        fill='currentColor'
      />
    </svg>
  );
};
